import { extent } from 'd3-array';

export function getAxisExtent(graph, panel, side) {

	// select only the series for the given side (left or right)
	const relevantSeries = side === null
		? panel.config.series
		: panel.config.series.filter(s => s.config.side === side);

	// Get the data sets all in one big array
	const data = Array.prototype.concat.apply([], relevantSeries.map(s => {

		if (s.config.type === 'area') {

			// combine lower values with upper values
			const lower = graph.config.data.map(d => {
				const value = s.config.dataAccessor(d);
				return value === null ? null : value[0];
			});

			const upper = graph.config.data.map(d => {
				const value = s.config.dataAccessor(d);
				return value === null ? null : value[1];
			});

			return lower.concat(upper)
				.filter(value => value !== null);

		}

		return graph.config.data
			.map(s.config.dataAccessor)
			.filter(value => value !== null);

	}));

	return data.length > 0 ? extent(data) : [0, 0];

}



// WEBPACK FOOTER //
// ./utils/panelgraph/functions/get-axis-extent.js